import { render, staticRenderFns } from "./AdminStoragePanel.vue?vue&type=template&id=557c2d2e"
import script from "./AdminStoragePanel.vue?vue&type=script&lang=ts"
export * from "./AdminStoragePanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports